import { useEffect, useState } from "react";

/** How long a wait lasts before the user is told the connection is slow. */
export const SLOW_AFTER_MS = 4000;

/**
 * Whether `isWaiting` has been true for longer than `afterMs` without a
 * break: a request that is late enough for the user to wonder whether
 * anything is happening. Back to `false` as soon as the wait ends.
 */
export function useIsSlow(isWaiting: boolean, afterMs = SLOW_AFTER_MS): boolean {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    if (!isWaiting) {
      setIsSlow(false);
      return;
    }
    const timeout = window.setTimeout(() => setIsSlow(true), afterMs);
    return () => window.clearTimeout(timeout);
  }, [isWaiting, afterMs]);

  return isWaiting && isSlow;
}
